<template>
  <div id="customer">
    <NotificationActions v-if="notificationMessage" :message="notificationMessage" @close="notificationMessage = ''" />

    <form @submit.prevent="submit()" autocomplete="off" id="clientForm" v-on:keypress.enter.prevent="enterKey">
      <div class="row mx-1">
        <div class="col-12">
          <h3 class="generalSubtitle">Datos Cliente</h3>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="name"><span className='text-danger'>*</span> Nombre</label>
            <input type="text" class="form-control generalInput"   id="name"
              v-model.trim.lazy="v$.name.$model" maxlength="40">
            <div v-if="v$.name.$dirty">
              <small class="form-text text-danger" v-if="v$.name.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.name.alphaAccents.$invalid && !v$.name.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="cif"><span className='text-danger'>*</span> CIF</label>
            <input type="text" class="form-control generalInput"   id="cif"
              v-model.trim.lazy="v$.cif.$model">
            <div v-if="v$.cif.$dirty">
              <small class="form-text text-danger" v-if="v$.cif.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.cif.validateCIF.$invalid && !v$.cif.required.$invalid">CIF
                incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="cnae">CNAE</label>
            <input type="text" class="form-control generalInput"   id="cnae"
              v-model.trim.lazy="v$.cnae.$model">
            <div v-if="v$.cnae.$dirty">
              <small class="form-text text-danger" v-if="v$.cnae.validateCNAE.$invalid">CNAE
                incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="nEmployees"><span className='text-danger'>*</span> Número de
              empleados</label>
            <input type="text" class="form-control generalInput"   id="nEmployees"
              v-model.trim.lazy="v$.nEmployees.$model">
            <div v-if="v$.nEmployees.$dirty">
              <small class="form-text text-danger"
                v-if="v$.nEmployees.numeric.$invalid && !v$.nEmployees.required.$invalid">El
                formato no es correcto</small>
              <small class="form-text text-danger" v-if="v$.nEmployees.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <!--<div class="col-12 col-lg-4" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="constitutionDate"><span className='text-danger'>*</span> Fecha
              constitución</label>
            <DatePicker v-model="v$.constitutionDate.$model" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control generalInput bg-white" readonly
                  v-model="v$.constitutionDate.$model" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
            <div v-if="v$.constitutionDate.$dirty">
              <small class="form-text text-danger" v-if="v$.constitutionDate.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>-->
        <div class="col-12 col-lg-4" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="surname1"><span className='text-danger'>*</span> Apellido 1</label>
            <input type="text" class="form-control generalInput"   id="surname1"
              v-model.trim.lazy="v$.surname1.$model">
            <div v-if="v$.surname1.$dirty">
              <small class="form-text text-danger" v-if="v$.surname1.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.surname1.alphaAccents.$invalid && !v$.surname1.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="surname2"><span className='text-danger'>*</span>Apellido 2</label>
            <input type="text" class="form-control generalInput"   id="surname2"
              v-model.trim.lazy="v$.surname2.$model">
            <div v-if="v$.surname2.$dirty">
              <small class="form-text text-danger" v-if="v$.surname2.alphaAccents.$invalid">El formato no es
                correcto</small>
            </div>
          </div>
        </div>
        <div class="col-4 col-lg-4" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="documentType"><span className='text-danger'>*</span> Tipo documento</label>
            <VueNextSelect class="form-control generalInput" id="documentType" :options="tipoDocumento"
              v-model.trim.lazy="v$.documentType.$model" placeholder="" close-on-select></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.documentType.$dirty">
              <small class="form-text text-danger" v-if="v$.documentType.required.$invalid">Campo requerido</small>
            </div>

          </div>
        </div>
        <div class="col-8 col-lg-4" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="documentNumber"><span className='text-danger'>*</span> Nº Documento</label>
            <input type="text" class="form-control generalInput"   id="documentNumber"
              v-model.trim.lazy="v$.documentNumber.$model">
            <div v-if="v$.documentNumber.$dirty">
              <small class="form-text text-danger" v-if="v$.documentNumber.required.$invalid">Campo
                requerido</small>
              <small class="form-text text-danger"
                v-if="v$.documentNumber.dniNumber.$invalid && !v$.documentNumber.required.$invalid">DNI
                incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="mobile"><span className='text-danger'>*</span> Teléfono</label>
            <input type="text" class="form-control generalInput"   id="mobile" maxlength="11"
              v-model.trim.lazy="v$.mobile.$model">
            <div v-if="v$.mobile.$dirty">
              <small class="form-text text-danger" v-if="v$.mobile.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.mobile.numeric.$invalid">El
                formato no es correcto</small>
              <small class="form-text text-danger" v-if="v$.mobile.minLength.$invalid">La
                longitud no es correcta</small>
            </div>
          </div>
        </div>
        <!--<div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="telephone">Teléfono fijo</label>
            <input type="text" class="form-control generalInput"   id="telephone" maxlength="11"
              v-model.trim.lazy="v$.telephone.$model">
            <div v-if="v$.telephone.$dirty">
              <small class="form-text text-danger" v-if="v$.telephone.numeric.$invalid">El formato no es
                correcto</small>
              <small class="form-text text-danger"
                v-if="v$.telephone.minLength.$invalid && !v$.telephone.numeric.$invalid">El formato no es
                correcto</small>
            </div>
          </div>
        </div>-->
        <div class="col-12 col-lg-4" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="birthdate"><span className='text-danger'>*</span> Fecha nacimiento</label>
            <DatePicker v-model="v$.birthdate.$model" mode="date" :max-date="disabled18Years" :model-config="modelConfig" class="birthdateSelect">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control generalInput bg-white" readonly
                  v-model="v$.birthdate.$model" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
            <div v-if="v$.birthdate.$dirty">
              <small class="form-text text-danger" v-if="v$.birthdate.required.$invalid">Campo requerido</small>
              <!--<small class="form-text text-danger" v-if="!v$.birthdate.mustBe21YearsOld.$invalid">Debes ser mayor de 21 años</small>-->
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="email"><span className='text-danger' v-if="!$store.state.roles.Backoffice_member_empresas">*</span>
              Email</label>
            <input type="text" class="form-control generalInput"   id="email"
              v-model.trim.lazy="v$.email.$model" autocomplete="off">
            <div v-if="v$.email.$dirty">
              <small class="form-text text-danger" v-if="v$.email.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.email.email.$invalid && !v$.email.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1" v-if="$store.state.roles.Backoffice_member_empresas">
        <div class="col-12">
          <h3 class="generalSubtitle">Autorizado</h3>
        </div>
      </div>
      <div class="row mx-1" v-if="$store.state.roles.Backoffice_member_empresas">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="nameAuthorization1"><span className='text-danger'>*</span> Nombre</label>
            <input type="text" class="form-control generalInput"   id="nameAuthorization1"
              v-model.trim.lazy="v$.authorization1Name.$model" maxlength="40">
            <div v-if="v$.authorization1Name.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization1Name.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization1Name.alphaAccents.$invalid && !v$.name.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="surnamesAuthorization1"><span className='text-danger'>*</span> Apellidos</label>
            <input type="text" class="form-control generalInput"   id="surnamesAuthorization1"
              v-model.trim.lazy="v$.authorization1Surnames.$model" maxlength="80">
            <div v-if="v$.authorization1Surnames.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization1Surnames.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization1Surnames.alphaAccents.$invalid && !v$.authorization1Surnames.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="dniAuthorization1"><span className='text-danger'>*</span> DNI</label>
            <input type="text" class="form-control generalInput"   id="dniAuthorization1"
              v-model.trim.lazy="v$.authorization1Dni.$model" maxlength="40">
            <div v-if="v$.authorization1Dni.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization1Dni.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization1Dni.dniNumber.$invalid && !v$.authorization1Dni.required.$invalid">DNI
                incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="mobileAuthorization1"><span className='text-danger'>*</span> Teléfono</label>
            <input type="text" class="form-control generalInput"   id="mobileAuthorization1" maxlength="11"
              v-model.trim.lazy="v$.authorization1Phone.$model">
            <div v-if="v$.authorization1Phone.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization1Phone.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.authorization1Phone.numeric.$invalid">El
                formato no es correcto</small>
              <small class="form-text text-danger" v-if="v$.authorization1Phone.minLength.$invalid">La
                longitud no es correcta</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="emailAuthorization1"><span className='text-danger'>*</span> Email</label>
            <input type="text" class="form-control generalInput"   id="emailAuthorization1"
              v-model.trim.lazy="v$.authorization1Mail.$model" autocomplete="off">
            <div v-if="v$.authorization1Mail.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization1Mail.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization1Mail.email.$invalid && !v$.authorization1Mail.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="powers1"><span className='text-danger'>*</span> Poderes</label>
            <VueNextSelect class="form-control generalInput" id="powers1" :options="['Si', 'No']"
              v-model.trim.lazy="v$.authorization1Powers.$model" placeholder="" close-on-select></VueNextSelect>
            <div v-if="v$.authorization1Powers.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization1Powers.required.$invalid">Campo
                requerido</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1" v-if="$store.state.roles.Backoffice_member_empresas && addAuth">
        <div class="col-12">
          <h3 class="generalSubtitle">Autorizado 2</h3>
        </div>
      </div>
      <div class="row mx-1" v-if="$store.state.roles.Backoffice_member_empresas && addAuth">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="nameAuthorization2"><span className='text-danger'>*</span> Nombre</label>
            <input type="text" class="form-control generalInput"   id="nameAuthorization2"
              v-model.trim.lazy="v$.authorization2Name.$model" maxlength="40">
            <div v-if="v$.authorization2Name.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization2Name.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization2Name.alphaAccents.$invalid && !v$.name.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="surnamesAuthorization2"><span className='text-danger'>*</span> Apellidos</label>
            <input type="text" class="form-control generalInput"   id="surnamesAuthorization2"
              v-model.trim.lazy="v$.authorization2Surnames.$model" maxlength="80">
            <div v-if="v$.authorization2Surnames.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization2Surnames.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization2Surnames.alphaAccents.$invalid && !v$.authorization2Surnames.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="dniAuthorization2"><span className='text-danger'>*</span> DNI</label>
            <input type="text" class="form-control generalInput"   id="dniAuthorization2"
              v-model.trim.lazy="v$.authorization2Dni.$model" maxlength="40">
            <div v-if="v$.authorization2Dni.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization2Dni.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization2Dni.dniNumber.$invalid && !v$.authorization2Dni.required.$invalid">DNI
                incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="mobileAuthorization2"><span className='text-danger'>*</span> Teléfono</label>
            <input type="text" class="form-control generalInput"   id="mobileAuthorization2" maxlength="11"
              v-model.trim.lazy="v$.authorization2Phone.$model">
            <div v-if="v$.authorization2Phone.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization2Phone.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.authorization2Phone.numeric.$invalid">El
                formato no es correcto</small>
              <small class="form-text text-danger" v-if="v$.authorization2Phone.minLength.$invalid">La
                longitud no es correcta</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="emailAuthorization2"><span className='text-danger'>*</span> Email</label>
            <input type="text" class="form-control generalInput"   id="emailAuthorization2"
              v-model.trim.lazy="v$.authorization2Mail.$model" autocomplete="off">
            <div v-if="v$.authorization2Mail.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization2Mail.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.authorization2Mail.email.$invalid && !v$.authorization2Mail.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="powers2"><span className='text-danger'>*</span> Poderes</label>
            <VueNextSelect class="form-control generalInput" id="powers2" :options="['Si', 'No']"
              v-model.trim.lazy="v$.authorization2Powers.$model" placeholder="" close-on-select></VueNextSelect>
            <div v-if="v$.authorization2Powers.$dirty">
              <small class="form-text text-danger" v-if="v$.authorization2Powers.required.$invalid">Campo
                requerido</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1 mt-2" v-if="$store.state.roles.Backoffice_member_empresas">
        <div class="col-12">
          <a href="#" class="mb-2" @click="addAuth = true" v-if="!addAuth">
            <v-icon name="hi-plus" scale="1.1" /> Añadir nuevo autorizado
          </a>
          <a href="#" class="mb-2" @click="addAuth = false" v-if="addAuth">
            <v-icon name="hi-minus" scale="1.1" /> Quitar autorizado
          </a>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12">
          <h3 class="generalSubtitle">Dirección</h3>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-4 col-lg-2">
          <div class="form-group">
            <label class="generalLabel" for="streetType"><span className='text-danger'>*</span> Tipo de Vía</label>
            <VueNextSelect class="form-control generalInput" id="streetType" :options="tipoDireccion"
              v-model.trim.lazy="v$.streetType.$model" placeholder="" close-on-select></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.streetType.$dirty">
              <small class="form-text text-danger" v-if="v$.streetType.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-8 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="street"><span className='text-danger'>*</span> Nombre de la vía</label>
            <input type="text" class="form-control generalInput"   id="street"
              v-model.trim.lazy="v$.street.$model">
            <div v-if="v$.street.$dirty">
              <small class="form-text text-danger" v-if="v$.street.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.street.addressCaracters.$invalid && !v$.street.required.$invalid">Formato invalido</small>
            </div>
          </div>
        </div>
        <div class=" col-12 col-lg-6">
          <div class="row">
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="number"><span className='text-danger'>*</span>Número</label>
                <input type="text" class="form-control generalInput"   id="number"
                  v-model.trim.lazy="v$.number.$model">
                <div v-if="v$.number.$dirty">
                  <small class="form-text text-danger" v-if="v$.number.required.$invalid">Campo requerido</small>
                  <small class="form-text text-danger"
                    v-if="v$.number.addressCaracters.$invalid && !v$.number.required.$invalid">Formato invalido</small>
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="floor">Piso</label>
                <input type="text" class="form-control generalInput"   id="floor"
                  v-model.trim.lazy="v$.floor.$model">
                <div v-if="v$.floor.$dirty">
                  <small class="form-text text-danger" v-if="v$.floor.addressCaracters.$invalid">Formato
                    invalido</small>
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="door">Puerta</label>
                <input type="text" class="form-control generalInput"   id="door"
                  v-model.trim.lazy="v$.door.$model">
                <div v-if="v$.door.$dirty">
                  <small class="form-text text-danger" v-if="v$.door.addressCaracters.$invalid">Formato
                    invalido</small>
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalLabel" for="stair">Escalera</label>
                <input type="text" class="form-control generalInput"   id="stair"
                  v-model.trim.lazy="v$.stair.$model">
                <div v-if="v$.stair.$dirty">
                  <small class="form-text text-danger" v-if="v$.stair.addressCaracters.$invalid">Formato
                    invalido</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="city"><span className='text-danger'>*</span> Localidad</label>
            <input type="text" class="form-control generalInput"   id="city"
              v-model.trim.lazy="v$.city.$model">
            <div v-if="v$.city.$dirty">
              <small class="form-text text-danger" v-if="v$.city.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.city.addressCaracters.$invalid && !v$.city.required.$invalid">Formato
                invalido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="state"><span className='text-danger'>*</span> Provincia</label>
            <VueNextSelect class="form-control generalInput" id="state" :options="provincesData"
              v-model.trim.lazy="v$.state.$model" placeholder="" close-on-select></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.state.$dirty">
              <small class="form-text text-danger" v-if="v$.state.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="postalCode"><span className='text-danger'>*</span> Código Postal</label>
            <input type="text" class="form-control generalInput"   id="postalCode"
              v-model.trim.lazy="v$.postalCode.$model">
            <div v-if="v$.postalCode.$dirty">
              <small class="form-text text-danger" v-if="v$.postalCode.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="sameAddress" v-model.trim.lazy="sameAddress">
            <label class="generalLabel custom-control-label" for="sameAddress">Usar una dirección de facturación
              diferente</label>
          </div>
        </div>
      </div>
      <div v-if="sameAddress">
        <div class="row mx-1">
          <div class="col-12">
            <h3 class="generalSubtitle">Dirección Facturación</h3>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-4 col-lg-2">
            <div class="form-group">
              <label class="generalLabel" for="streetTypeB"><span className='text-danger'>*</span> Tipo de Vía</label>
              <VueNextSelect class="form-control generalInput" id="streetTypeB" :options="tipoDireccion"
                v-model.trim.lazy="v$.streetTypeB.$model" placeholder="" close-on-select></VueNextSelect>
              <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
              <div v-if="v$.streetTypeB.$dirty">
                <small class="form-text text-danger" v-if="v$.streetTypeB.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-8 col-lg-4">
            <div class="form-group">
              <label class="generalLabel" for="streetB"><span className='text-danger'>*</span> Nombre de la vía</label>
              <input type="text" class="form-control generalInput"   id="streetB"
                v-model.trim.lazy="v$.streetB.$model">
              <div v-if="v$.streetB.$dirty">
                <small class="form-text text-danger" v-if="v$.streetB.required.$invalid">Campo requerido</small>
                <small class="form-text text-danger"
                  v-if="v$.streetB.addressCaracters.$invalid && !v$.streetB.required.$invalid">Formato invalido</small>
              </div>
            </div>
          </div>
          <div class=" col-12 col-lg-6">
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="generalLabel" for="numberB"><span className='text-danger'>*</span> Número</label>
                  <input type="text" class="form-control generalInput"   id="numberB"
                    v-model.trim.lazy="v$.numberB.$model">
                  <div v-if="v$.numberB.$dirty">
                    <small class="form-text text-danger" v-if="v$.numberB.required.$invalid">Campo requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.numberB.addressCaracters.$invalid && !v$.numberB.required.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="generalLabel" for="floorB">Piso</label>
                  <input type="text" class="form-control generalInput"   id="floorB"
                    v-model.trim.lazy="v$.floorB.$model">
                  <div v-if="v$.floorB.$dirty">
                    <small class="form-text text-danger" v-if="v$.floorB.addressCaracters.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="generalLabel" for="doorB">Puerta</label>
                  <input type="text" class="form-control generalInput"   id="doorB"
                    v-model.trim.lazy="v$.doorB.$model">
                  <div v-if="v$.doorB.$dirty">
                    <small class="form-text text-danger" v-if="v$.doorB.addressCaracters.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="generalLabel" for="stairB">Escalera</label>
                  <input type="text" class="form-control generalInput"   id="stairB"
                    v-model.trim.lazy="v$.stairB.$model">
                  <div v-if="v$.postalCodeB.$dirty">
                    <small class="form-text text-danger" v-if="v$.postalCodeB.addressCaracters.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <label class="generalLabel" for="cityB"><span className='text-danger'>*</span> Localidad</label>
              <input type="text" class="form-control generalInput"   id="cityB"
                v-model.trim.lazy="v$.cityB.$model">
              <div v-if="v$.cityB.$dirty">
                <small class="form-text text-danger" v-if="v$.cityB.required.$invalid">Campo requerido</small>
                <small class="form-text text-danger"
                  v-if="v$.cityB.addressCaracters.$invalid && !v$.cityB.required.$invalid">Formato invalido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <label class="generalLabel" for="stateB"><span className='text-danger'>*</span> Provincia</label>
              <VueNextSelect class="form-control generalInput" id="stateB" :options="provincesData"
                v-model.trim.lazy="v$.stateB.$model" placeholder="" close-on-select></VueNextSelect>
              <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
              <div v-if="v$.stateB.$dirty">
                <small class="form-text text-danger" v-if="v$.stateB.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class=" col-12 col-lg-4">
            <div class="form-group mb-0">
              <label class="generalLabel" for="postalCodeB"><span className='text-danger'>*</span> Código Postal</label>
              <input type="text" class="form-control generalInput"   id="postalCodeB"
                v-model.trim.lazy="v$.postalCodeB.$model">
              <div v-if="v$.postalCodeB.$dirty">
                <small class="form-text text-danger" v-if="v$.postalCodeB.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 mx-1">
        <div class="col-12">
          <button class="btn btn-outline-secondary float-left generalSecondaryButton"
            @click="goBack($event)">Atrás</button>

          <button class="btn btn-primary float-right generalPrimaryButton" id="submitButton"
                  :class="{ disabled: v$.$invalid || isLoading }" :disabled="v$.$invalid || isLoading">
            <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-else>Continuar</span>
          </button>


        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { DatePicker } from 'v-calendar';
import useVuelidate from '@vuelidate/core';
import provincias from '../../../../../data/provinces.json'
import NotificationActions from "@/components/Widgets/Shared/NotificationActions.vue";
import {
  required,
  email,
  numeric,
  minLength,
  requiredIf,
} from '@vuelidate/validators'
import VueNextSelect from 'vue-next-select'


/*const mustBe21YearsOld = (value) => {
  const myBirthday = new Date(value);
  const currentDate = `${new Date().toJSON().slice(0, 10)} 01:00:00`;
  const myAge = ~~((Date.now(currentDate) - myBirthday) / (31557600000));

  if (myAge < 21) {
    return false;
  }
  return true;
};*/
const alphaAccents = (value) => {
  if (value != '') {
    if (/[a-zA-ZÀ-ÿ\u00f1\u00d1]{2,3}/gi.test(value))
      return true
    else return false
  } else {
    return true
  }
}

const addressCaracters = (value) => {
  if (/[$%&|<>#=¿?¡!@~¬/{}[-_()*+´¨`^¢.,:;\]\\·"'€]/gi.test(value))
    return false
  else return true
}

const dniNumber = (value) => {
  if (value != '' && value != undefined) {
    var numero, le, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    value = value.toUpperCase();

    if (expresion_regular_dni.test(value) === true) {
      numero = value.substr(0, value.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      le = value.substr(value.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra != le) {
        return false;
      } else {
        return true;
      }
    } else {
      return validateCIF(value)
    }
  } else {
    return true
  }
}

const validateCIF = (value) => {
  if (value != "" && value != undefined) {
    value = value.trim().toUpperCase();
    if (value.length !== 9) {
      return false;
    }
    const letras = 'ABCDEFGHJKLMNPQRSUVW';
    const digitoControl = value.charAt(8);

    if (!/[A-W0-9]/.test(digitoControl)) {
      return false;
    }

    const digitos = value.slice(1, 8);

    let sumaPares = 0;
    let sumaImpares = 0;

    for (let i = 0; i < digitos.length; i++) {
      let digito = parseInt(digitos.charAt(i), 10);
      if (i % 2 === 0) {
        digito *= 2;
        if (digito > 9) {
          digito = digito - 9;
        }
        sumaPares += digito;
      } else {
        sumaImpares += digito;
      }
    }
    const sumaTotal = sumaPares + sumaImpares;
    const unidad = sumaTotal % 10;
    const digitoControlCalculado = unidad === 0 ? 0 : 10 - unidad;
    if (/[0-9]/.test(digitoControl)) {
      return parseInt(digitoControl, 10) === digitoControlCalculado;
    } else {
      return digitoControl === letras.charAt(digitoControlCalculado-1);
    }
  } else {
    return true;
  }
}

const validateCNAE = (value) => {
  if (value != '' && value != undefined) {
    // Remove any whitespace from the input
    value = value.replace(/\s/g, '');
    // Check if the input matches the expected format
    if (/^[0-9]{4}[A-Z]{1}$/.test(value)) {
      // Check if the input is a valid CNAE code
      let firstDigit = parseInt(value.charAt(0));
      if (firstDigit < 1 || firstDigit > 9 || firstDigit === 8) {
        return false;
      }
      let cnaeNumber = parseInt(value.substring(0, 3));
      if (cnaeNumber < 1 || cnaeNumber > 981) {
        return false;
      }
      // The input is a valid CNAE code
      return true;
    } else {
      // The input does not match the expected format
      return false;
    }
  } else {
    return true
  }
}

export default {
  name: 'customer',
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    DatePicker,
    VueNextSelect,
    NotificationActions
  },
  data() {
    return {
      isLoading: false,
      notificationMessage: '',
      name: this.$store.state.newContractData.customer.name,
      surname1: this.$store.state.newContractData.customer.surname1,
      surname2: this.$store.state.newContractData.customer.surname2,
      documentType: this.$store.state.newContractData.customer.documentType,
      documentNumber: this.$store.state.newContractData.customer.legalIdentifier,
      mobile: this.$store.state.roles.Backoffice_member_empresas ? this.$store.state.newContractData.customer.phone : this.$store.state.newContractData.customer.mobile, 
      //telephone: this.$store.state.newContractData.customer.telephone,
      birthdate: this.$store.state.newContractData.customer.birthdate,
      email: this.$store.state.newContractData.customer.email,
      streetType: this.$store.state.newContractData.customer.deliveryAddress.streetType,
      street: this.$store.state.newContractData.customer.deliveryAddress.street,
      number: this.$store.state.newContractData.customer.deliveryAddress.number,
      floor: this.$store.state.newContractData.customer.deliveryAddress.floor,
      door: this.$store.state.newContractData.customer.deliveryAddress.door,
      stair: this.$store.state.newContractData.customer.deliveryAddress.stair,
      postalCode: this.$store.state.newContractData.customer.deliveryAddress.postalCode,
      city: this.$store.state.newContractData.customer.deliveryAddress.city,
      country: this.$store.state.newContractData.customer.deliveryAddress.country,
      state: this.$store.state.newContractData.customer.deliveryAddress.province,
      sameAddress: this.$store.state.newContractData.customer.billingAddress.sameAddress,
      streetTypeB: this.$store.state.newContractData.customer.billingAddress.streetType,
      streetB: this.$store.state.newContractData.customer.billingAddress.street,
      numberB: this.$store.state.newContractData.customer.billingAddress.number,
      floorB: this.$store.state.newContractData.customer.billingAddress.floor,
      doorB: this.$store.state.newContractData.customer.billingAddress.door,
      stairB: this.$store.state.newContractData.customer.billingAddress.stair,
      postalCodeB: this.$store.state.newContractData.customer.billingAddress.postalCode,
      cityB: this.$store.state.newContractData.customer.billingAddress.city,
      countryB: this.$store.state.newContractData.customer.billingAddress.country,
      stateB: this.$store.state.newContractData.customer.billingAddress.province,
      cif: this.$store.state.roles.Backoffice_member_empresas ? this.$store.state.newContractData.customer.legalIdentifier : '',
      cnae: this.$store.state.newContractData.customer.cname,
      nEmployees: this.$store.state.newContractData.customer.numberEmployees,
      //constitutionDate: this.$store.state.newContractData.customer.cif,
      authorization1Name: this.$store.state.newContractData.customer.companyContact ? this.$store.state.newContractData.customer.companyContact[0].name : '',
      authorization1Surnames: this.$store.state.newContractData.customer.companyContact ? this.$store.state.newContractData.customer.companyContact[0].surnames : '',
      authorization1Dni: this.$store.state.newContractData.customer.companyContact ? this.$store.state.newContractData.customer.companyContact[0].legalIdentifier : '',
      authorization1Phone: this.$store.state.newContractData.customer.companyContact ? this.$store.state.newContractData.customer.companyContact[0].mobile : '',
      authorization1Mail: this.$store.state.newContractData.customer.companyContact ? this.$store.state.newContractData.customer.companyContact[0].email : '',
      authorization1Powers: this.$store.state.newContractData.customer.companyContact ? this.$store.state.newContractData.customer.companyContact[0].powers : '',
      authorization2Name: this.$store.state.newContractData.customer.companyContact && this.$store.state.newContractData.customer.companyContact[1] ? this.$store.state.newContractData.customer.companyContact[1].name : '',
      authorization2Surnames: this.$store.state.newContractData.customer.companyContact && this.$store.state.newContractData.customer.companyContact[1] ? this.$store.state.newContractData.customer.companyContact[1].surnames : '',
      authorization2Dni: this.$store.state.newContractData.customer.companyContact && this.$store.state.newContractData.customer.companyContact[1] ? this.$store.state.newContractData.customer.companyContact[1].legalIdentifier : '',
      authorization2Phone: this.$store.state.newContractData.customer.companyContact && this.$store.state.newContractData.customer.companyContact[1] ? this.$store.state.newContractData.customer.companyContact[1].mobile : '',
      authorization2Mail: this.$store.state.newContractData.customer.companyContact && this.$store.state.newContractData.customer.companyContact[1] ? this.$store.state.newContractData.customer.companyContact[1].email : '',
      authorization2Powers: this.$store.state.newContractData.customer.companyContact && this.$store.state.newContractData.customer.companyContact[1] ? this.$store.state.newContractData.customer.companyContact[1].powers : '',
      addAuth: false,
      disabledDates: {
        from: new Date(),
      },
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      provincesData: provincias,
      tipoDocumento: ['DNI', 'CIF', 'NIE'],
      tipoDireccion: ['Calle', 'Avenida', 'Plaza', 'Carretera', 'Travesía'],
    };
  },
  validations() {
    return {
      name: {
        required,
        alphaAccents,
      },
      surname1: {
        required: requiredIf(function () {
          return !this.$store.state.roles.Backoffice_member_empresas;
        }),
        alphaAccents,
      },
      surname2: {
        required: requiredIf(function () {
          return !this.$store.state.roles.Backoffice_member_empresas;
        }),
        alphaAccents,
      },
      documentType: {
        required: requiredIf(function () {
          return !this.$store.state.roles.Backoffice_member_empresas;
        }),
      },
      documentNumber: {
        required: requiredIf(function () {
          return !this.$store.state.roles.Backoffice_member_empresas;
        }),
        dniNumber
      },
      mobile: {
        required,
        numeric,
        minLength: minLength(9),
      },
      /*telephone: {
        numeric,
        minLength: minLength(9),
      },*/
      email: {
        required: requiredIf(function () {
          return !this.$store.state.roles.Backoffice_member_empresas;
        }),
        email,
      },
      birthdate: {
        required: requiredIf(function () {
          return !this.$store.state.roles.Backoffice_member_empresas;
        }),
      },
      streetType: {
        required,
      },
      street: {
        required,
        addressCaracters
      },
      number: {
        required,
        addressCaracters
      },
      floor: {
        addressCaracters
      },
      door: {
        addressCaracters
      },
      stair: {
        addressCaracters
      },
      postalCode: {
        required,
      },
      city: {
        required,
        addressCaracters
      },
      state: {
        required,
      },
      streetTypeB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
      },
      streetB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      numberB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      floorB: {
        addressCaracters
      },
      doorB: {
        addressCaracters
      },
      stairB: {
        addressCaracters
      },
      postalCodeB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      cityB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      stateB: {
        required: requiredIf(function () {
          return this.sameAddress;
        })
      },
      cif: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        validateCIF
      },
      cnae: {
        validateCNAE
      },
      nEmployees: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        numeric,
      },
      /*constitutionDate: {
        required: requiredIf(function () {
          return false;
        }),
      },*/
      authorization1Name: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        alphaAccents,
      },
      authorization1Surnames: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        alphaAccents,
      },
      authorization1Dni: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        dniNumber,
      },
      authorization1Phone: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        numeric,
        minLength: minLength(9),
      },
      authorization1Mail: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
        email,
      },
      authorization1Powers: {
        required: requiredIf(function () {
          return this.$store.state.roles.Backoffice_member_empresas;
        }),
      },
      authorization2Name: {
        required: requiredIf(function () {
          return this.addAuth;
        }),
        alphaAccents,
      },
      authorization2Surnames: {
        required: requiredIf(function () {
          return this.addAuth;
        }),
        alphaAccents,
      },
      authorization2Dni: {
        required: requiredIf(function () {
          return this.addAuth;
        }),
        dniNumber
      },
      authorization2Phone: {
        required: requiredIf(function () {
          return this.addAuth;
        }),
        numeric,
        minLength: minLength(9),
      },
      authorization2Mail: {
        required: requiredIf(function () {
          return this.addAuth;
        }),
        email,
      },
      authorization2Powers: {
        required: requiredIf(function () {
          return this.addAuth;
        }),
      },
    }
  },
  computed: {
    disabled18Years() {
      // `this` apunta a la instancia vm
      let eighteenYearsAgo = this.disabledDates.from.setFullYear(this.disabledDates.from.getFullYear() - 18);
      eighteenYearsAgo = new Date(eighteenYearsAgo);
      return eighteenYearsAgo;
    },
  },
  methods: {
    submit() {


      this.isLoading = true;

      this.$store.commit('setLoading', true);
      var bodyToSave = '';
      if (this.$store.state.roles.Backoffice_member_empresas) {
        bodyToSave = {
          legalIdentifier: this.cif.trim(),
          ninControl: this.cif.trim(),
          name: this.name.trim(),
          email: this.email.trim(),
          phone: this.mobile.trim(),
          languageCode: "ES",
          cname: this.cnae ? this.cnae.trim() : '',
          numberEmployees: this.nEmployees.trim(),
          companyContact: [
            {
              name: this.authorization1Name.trim(),
              surnames: this.authorization1Surnames.trim(),
              legalIdentifier: this.authorization1Dni.trim(),
              mobile: this.authorization1Phone.trim(),
              email: this.authorization1Mail.trim(),
              powers: this.authorization1Powers
            }
          ]
        };
        if (this.authorization2Name != '' && this.authorization2Name != undefined) {
          bodyToSave.companyContact.push({
            name: this.authorization2Name.trim(),
            surnames: this.authorization2Surnames.trim(),
            legalIdentifier: this.authorization2Dni.trim(),
            mobile: this.authorization2Phone.trim(),
            email: this.authorization2Mail.trim(),
            powers: this.authorization2Powers
          })
        }
      } else {
        bodyToSave = {
          name: this.name.trim(),
          surname1: this.surname1.trim(),
          surname2: this.surname2.trim(),
          legalIdentifier: this.documentNumber.trim(),
          mobile: this.mobile.trim(),
          //telephone: this.telephone ? this.telephone.trim() : '',
          birthdate: this.birthdate,
          email: this.email.trim(),
          language: '',
          documentType: this.documentType,
        };
      }
      bodyToSave.deliveryAddress = {
        street: this.street.trim(),
        number: this.number.trim(),
        floor: this.floor ? this.floor.trim() : '',
        door: this.door ? this.door.trim() : '',
        stair: this.stair ? this.stair.trim() : '',
        postalCode: this.postalCode.trim(),
        city: this.city,
        country: 'España',
        province: this.state.trim(),
        streetType: this.streetType,
      }
      bodyToSave.billingAddress = {
        sameAddress: this.sameAddress,
        street: !this.sameAddress ? this.street.trim() : this.streetB.trim(),
        number: !this.sameAddress ? this.number.trim() : this.numberB.trim(),
        floor: !this.sameAddress ? (this.floor ? this.floor.trim() : '') : (this.floorB ? this.floorB.trim() : ''),
        door: !this.sameAddress ? (this.door ? this.door.trim() : '') : (this.doorB ? this.doorB.trim() : ''),
        stair: !this.sameAddress ? (this.stair ? this.stair.trim() : '') : (this.stairB ? this.stairB.trim() : ''),
        postalCode: !this.sameAddress ? this.postalCode.trim() : this.postalCodeB.trim(),
        city: !this.sameAddress ? this.city : this.cityB,
        country: 'España',
        province: !this.sameAddress ? this.state.trim() : this.stateB.trim(),
        streetType: !this.sameAddress ? this.streetType : this.streetTypeB
      }
      console.log(bodyToSave)

      if (this.v$.$invalid) {
        this.notificationMessage = 'Por favor, completa correctamente los campos obligatorios.';
        return;
      }

      this.$store.commit('setNewContractDataCustomer', bodyToSave);

      this.notificationMessage = 'Datos del cliente guardados exitosamente.';

      setTimeout(() => {
        this.$router.push({ name: 'newContractStep3' });
      }, 1500);
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        if (!document.getElementById('submitButton').classList.contains('disabled')) {
          this.submit();
        }
      }
    },
    goBack(event) {
      event.preventDefault();
      this.$router.push({ name: 'newContractStep1' })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vue-select {
  z-index: 20;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
  color: white;
}
</style>